import React, { useEffect, useState } from "react";
import { submitMessage } from "../ChatScripts";
import { NewMessage } from "../ChatInterfaces";
import { useSelector, DefaultRootState } from "react-redux";
import { updateNotificationList } from "../firebaseCRUD";
import { useChat } from "../../../../../context/ChatContext/ChatContext";
import { useIntl } from "react-intl";
import TextareaWithOptions from "./TextareaWithOptions";

import "../ChatStyle.less";
import { Icon_ChatSendMessage } from "../../../../BP2Components/Icons/icons";
import TypingIndicator from "./TypingIndicator";

interface ChatInputProps {}

const INITIAL_MESSAGE = {
   userId: "",
   roomId: "",
   title: "",
   chatUser: "",
   content: "",
   date: "",
   type: "",
};
const ChatInput: React.FC<ChatInputProps> = ({}) => {
   const [newMessage, setNewMessage] = useState<NewMessage>(INITIAL_MESSAGE);
   const [showErrorMessage, setShowErrorMessage] = useState({
      showErrorMessage: false,
      errorMessage: "",
   });

   const chatSettings = useSelector((state: DefaultRootState) => state.chatSettings);
   const { oldId, firstName, lastName } = useSelector((state: DefaultRootState) => state?.user);

   const chatData = useChat();

   const intl = useIntl();

   const currentRoom = chatData?.chatData?.allRooms?.find(
      (room) => room?.id === chatSettings?.currentRoom?.id,
   );

   const handleErrorMessage = (errorMessage) => {
      if (errorMessage?.showErrorMessage === true && errorMessage?.errorMessage !== "") {
         setTimeout(() => {
            setShowErrorMessage({
               showErrorMessage: false,
               errorMessage: "",
            });
         }, 5000);
      }
   };

   useEffect(() => {
      handleErrorMessage(showErrorMessage);
   }, [showErrorMessage]);

   useEffect(() => {
      setNewMessage(INITIAL_MESSAGE);
   }, [currentRoom?.id]);

   const getBotInfo = () => {
      if (chatSettings?.currentRoom?.hasOwnProperty("GPTBotId")) {
         const botInfo = chatData?.chatData?.users.find(
            (user) => user.oldId === chatSettings?.currentRoom?.GPTBotId,
         );
         if (botInfo?.firstName) {
            return [`${botInfo?.firstName}`];
         } else {
            return [intl.formatMessage({ id: "chat-no-assistant" })];
         }
      }
      return [];
   };

   const handleChange = (e) => {
      setNewMessage({ ...newMessage, content: e.target.value });
   };

   const handleSubmit = (e) => {
      submitMessage(
         e,
         newMessage,
         oldId,
         chatSettings,
         firstName,
         lastName,
         setNewMessage,
         updateNotificationList,
         chatData?.chatData,
         setShowErrorMessage,
         intl,
      );
   };

   return (
      <div className="chat-input-box">
         <div className="chat-typing-indicator-container ">
            {currentRoom?.isAsistantBusy === "true" ? <TypingIndicator /> : null}
         </div>
         <div className="chat-textarea-container">
            <TextareaWithOptions
               options={getBotInfo()}
               newMessage={newMessage}
               setNewMessage={setNewMessage}
               chatSettings={chatSettings}
               intl={intl}
               onChange={handleChange}
               onKeyPressed={(e) => handleSubmit(e)}
            />
            <div
               onClick={(e) =>
                  submitMessage(
                     e,
                     newMessage,
                     oldId,
                     chatSettings,
                     firstName,
                     lastName,
                     setNewMessage,
                     updateNotificationList,
                     chatData?.chatData,
                     setShowErrorMessage,
                     intl,
                  )
               }
               style={{ cursor: "pointer" }}
            >
               <Icon_ChatSendMessage fill="#1c4387" style={{ width: "16px", height: "16px" }} />
            </div>
         </div>
      </div>
   );
};

export default ChatInput;
